export default __webpack_public_path__ + "static/media/best.c0f00f1f.jpg";